import { Observable, of } from 'rxjs';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { debounceTime, distinctUntilChanged, first, map, switchMap, tap } from 'rxjs/operators';
import { EmailDomainPolicyDto } from '../../interfaces/email-domain-policy-dto';

const atSymbol = '@';
const emptyFn = () => {
    // NOOP
};

export const emailDomainValidator = (emailPolicies: () => Observable<EmailDomainPolicyDto>,
    validationError: (error: string) => void,
    beforeAction: () => void = emptyFn,
    afterAction: () => void = emptyFn,
    initialValue = ''
): AsyncValidatorFn =>
    (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
        const value = control.value;
        if (!control.dirty || !value || !value?.length || initialValue === value) {
            return of(null);
        }
        return of(value).pipe(
            debounceTime(500),
            distinctUntilChanged(),
            tap(beforeAction),
            switchMap(() => emailPolicies()),
            map(emailPolicy => {
                let emailError = '';
                const domains = emailPolicy.emailDomains;
                if (domains?.length) {
                    const emailDomain = getEmailDomain(value).toLowerCase();
                    if (!domains.some(domain => domain?.toLowerCase() === emailDomain)) {
                        emailError = 'Email address is not in the approved list of domains.';
                    }
                }
                validationError(emailError);
                return emailError.length ? { emailDomainPolicy: true } : null;
            }),
            tap(afterAction),
            first()
        );
    };

function getEmailDomain(email: string): string {
    return email.substring(email.lastIndexOf(atSymbol) + 1);
}
